export enum UserRole {
  Admin = 'Admin',
  Dealer = 'Dealer',
  Employee = 'Employee',
  Customer = 'Customer',
}
